import axios from "axios";
import moment from "moment";
import Cookies from "js-cookie";
import { useDropzone } from "react-dropzone";
import CONSTANTS from "src/components/services/api";
import ChatBox from "src/components/molecules/ChatBox";
import ClientAvatar from "src/components/atoms/ClientAvatar";
import loaderAnimation from "src/assets/loaderAnimation.gif";
import { useContext, useEffect, useState, memo, useRef } from "react";
import { generateThumbnail } from "src/services/functions/generateThumbnail";
import ChatInputComponent from "src/components/molecules/ChatInputComponent";
// import { findDifferentObjects } from "src/services/functions/sendMessagefunction";
import {
  AdminDashboardContext,
  MyContext,
} from "src/components/Context/MyContext";
import chatbackground from "src/assets/chatbackground.png";
import { toast, Bounce } from "react-toastify";

const ChatBoxComponent = () => {
  const bearerToken = Cookies.get("Token");
  const totalConversationHistory = useRef(null);
  // Element from context api
  const roleId = Cookies.get("roleId");
  const { selectedChat } = useContext(MyContext);
  const {
    messages,
    setMessages,
    sendTypingOffSignal,
    otherSide_status,
    setNewMessageOn,
    newMessageOn,
  } = useContext(AdminDashboardContext);

  const { socket, userId } = useContext(MyContext);
  const authorName = Cookies.get("name");
  const [replyMessage, setReplyMessage] = useState(null);
  const [pageNum, setPageNumber] = useState(1);
  const [stopRendering, setStopRendering] = useState(false);
  const [loadMsgLoading, setLoadMsgLoading] = useState(false);
  const [dropLoading, setDropLoading] = useState(false);
  const [showLoadmoreBtn, setShowLoadmoreBtn] = useState(true);

  const postUserDetail = async () => {
    try {
      const { data } = await axios.post(
        `${CONSTANTS.CHAT_BASE}/api/create-conversation`,
        {
          userId: userId,
          roomName: "",
          roomType: 1,
          participantsIds: [selectedChat.user_id],
          enrollmentId: selectedChat._id,
        }
      );
      return data.data.reference_conversation_id;
    } catch (error) {
      // setDataLoading(true);
      console.log("axios error :::", error);
    }
  };

  function findDifferentObjects(arr1, arr2) {
    const diffObjects = [];
    if (arr2?.length > 0) {
      arr2.forEach((obj2) => {
        const obj1 = arr1.find((item) => item._id === obj2._id);
        if (!obj1) {
          diffObjects.push(obj2);
        }
      });
    }

    return diffObjects;
  }

  function getConversationHistory(pageNumber) {
    postUserDetail().then((res) => {
      const payload = {
        conversationId: res,
        userId: userId,
        pageNum: pageNumber,
      };
      socket.emit("get-messages", payload);
      socket.on("conversation-history", (msg) => {
        if (stopRendering) {
          return;
        }
        const getMessageFromLocalState = JSON.parse(
          localStorage.getItem("my-message")
        );
        const showChat = JSON.parse(localStorage.getItem("showChat"));
        setLoadMsgLoading(false);
        if (msg.messageHistory.allConversations?.length == 0) {
          setShowLoadmoreBtn(false);
        }
        totalConversationHistory.current = msg.messageHistory.total;
        if (msg.messageHistory.allConversations?.length > 0) {
          setShowLoadmoreBtn(true);
          if (
            msg.messageHistory.allConversations[0].participantsIds[0] == userId
          ) {
            const readDetail = {
              messageId: msg.messageHistory.allConversations[0].conversationId,
              isRead: true,
              userId: userId,
              enrollment_id: String(showChat._id),
              participantsId: String(showChat.user_id),
            };
            socket.emit("read-message", readDetail);
            // setNewMessageOn(!newMessageOn);
          }
        }
        const messageTime = getMessageToken();
        const diffObjects = findDifferentObjects(
          getMessageFromLocalState,
          msg?.messageHistory.allConversations
        );
        const storeData = diffObjects.map((item, index) => {
          const providedTimestampInMilliseconds = item.messageTime / 10000000;
          const formattedTime = moment
            .unix(providedTimestampInMilliseconds)
            .format("hh:mm a");
          return {
            _id: item._id,
            messageId: item.messageId,
            fileName: "string",
            filePath: "",
            fileOriginalName: "",
            fileExtension: "",
            roomId: "",
            roomName: "",
            chatName: "",
            senderName: "",
            DateFormated: moment
              .unix(providedTimestampInMilliseconds)
              .format("DD/MM/YYYY"),
            audioDuration: item.audioDuration,
            author: item.senderId.toString(),
            senderId: userId,
            participantsIds: [String(showChat.user_id)],
            enrollmentId: String(showChat._id),
            // participantsIds: item.participantsIds,
            // enrollmentId: item.enrollmentId.toString(),
            authorName: item.senderName,
            content: item.message,
            isDeleted: item.isMessageDeletedForEveryone,
            isRead: item.isRead,
            messageTime: item.messageTime.toString(),
            timeFormated: formattedTime,
            type:
              item.message.split(".").pop() == "aac"
                ? "audio"
                : item.messageType,
            chatType: item.chatType,
            offline: false,
            hasAttachments: false,
            thumbnail: item.thumbnail,
            sendOnServer: true,
            replyMessage:
              item.replyMessage?.length > 0 ? [...item.replyMessage] : [],
          };
        });
        if (
          storeData.length > 0 &&
          storeData[0]?.enrollmentId === String(showChat._id)
        ) {
          setMessages((prev) => {
            return [...storeData, ...prev];
          });
          localStorage.setItem(
            "my-message",
            JSON.stringify([...storeData, ...getMessageFromLocalState])
          );
          setStopRendering(true);
        }
      });
    });
  }

  function loadOlderChat(currentPageNumber) {
    if (totalConversationHistory.current > messages.length) {
      setStopRendering(false);
      getConversationHistory(currentPageNumber);
    }
  }

  useEffect(() => {
    setStopRendering(false);
    socket.emit("new-connected", { userId: userId, platform: "Web" });
    getConversationHistory(1);
  }, [selectedChat]);

  useEffect(() => {
    socket.emit("online-user", {
      userId: userId,
      onlineStatus: true,
    });
  }, [selectedChat]);

  function getMessageToken() {
    const currentTimestampInMilliseconds = Date.now();
    const timestampInSeconds = Math.floor(
      currentTimestampInMilliseconds / 1000
    );
    const timestampMicroseconds =
      (currentTimestampInMilliseconds % 1000) * 1000;
    const pubnubTimestamp =
      timestampInSeconds * 1000000 + timestampMicroseconds;
    return pubnubTimestamp.toString();
  }

  // using for send the message
  function sendMessageData(inputData) {
    const id =
      new Date().getTime() + Math.random().toString(36).substring(2, 24);
    const currentTimestampInMilliseconds = Date.now();
    const timestampInSeconds = Math.floor(
      currentTimestampInMilliseconds / 1000
    );
    const timestampMicroseconds =
      (currentTimestampInMilliseconds % 1000) * 1000;
    const pubnubTimestamp =
      timestampInSeconds * 1000000 + timestampMicroseconds;
    const messageTime = pubnubTimestamp.toString();
    const providedTimestampInMicroseconds = messageTime;
    const providedTimestampInMilliseconds =
      providedTimestampInMicroseconds / 1000;
    const formattedTime = moment(providedTimestampInMilliseconds).format(
      "hh:mm a"
    );
    const dateFormated = moment(new Date()).format("DD/MM/YYYY");
    const showChat = JSON.parse(localStorage.getItem("showChat"));
    let payload = {
      _id: id,
      DateFormated: dateFormated,
      audioDuration: "0",
      author: userId,
      authorName: authorName,
      chatName: "",
      chatType: 1,
      content: inputData,
      enrollmentId: String(showChat._id),
      fileExtension: "",
      fileName: "",
      fileOriginalName: "",
      filePath: "",
      hasAttachments: false,
      isDeleted: false,
      isRead: false,
      messageId: "",
      messageTime: messageTime,
      offline: true,
      replyMessage: replyMessage ? [replyMessage] : [],
      roomId: "",
      roomName: "",
      sendOnServer: true,
      senderId: userId,
      senderName: showChat.username,
      thumbnail: "",
      timeFormated: formattedTime,
      type: "text",
    };
    if (roleId == "1") {
      payload = {
        ...payload,
        participantsIds: [String(showChat.user_id), String(showChat.coach_id)],
      };
    } else {
      payload = { ...payload, participantsIds: [String(showChat.user_id)] };
    }
    return payload;
  }

  const handleSendMsg = (inputData) => {
    const getMessageFromLocalState = JSON.parse(
      localStorage.getItem("my-message")
    );
    const sendMsg = sendMessageData(inputData);
    if (getMessageFromLocalState) {
      const existMessage = getMessageFromLocalState.findIndex(
        (message) => message._id === sendMsg._id
      );
      if (existMessage === -1) {
        socket.emit("send-message", sendMsg);
        sendTypingOffSignal();
        if (replyMessage !== null) {
          setReplyMessage(null);
        }
        setMessages([...messages, sendMsg]);
        localStorage.setItem(
          "my-message",
          JSON.stringify([sendMsg, ...getMessageFromLocalState])
        );
      }
    } else if (getMessageFromLocalState === null) {
      socket.emit("send-message", sendMsg);
      sendTypingOffSignal();
      if (replyMessage !== null) {
        setReplyMessage(null);
      }
      setMessages([...messages, sendMsg]);
      localStorage.setItem("my-message", JSON.stringify([sendMsg]));
    }
  };

  const handleMedia = (
    content,
    path,
    filename,
    type,
    thumbnail,
    duration = "0",
    cameraVideo
  ) => {
    const getMessageFromLocalState = JSON.parse(
      localStorage.getItem("my-message")
    );
    const id =
      new Date().getTime() + Math.random().toString(36).substring(2, 24);
    const currentTimestampInMilliseconds = Date.now();
    const timestampInSeconds = Math.floor(
      currentTimestampInMilliseconds / 1000
    );
    const timestampMicroseconds =
      (currentTimestampInMilliseconds % 1000) * 1000;
    const pubnubTimestamp =
      timestampInSeconds * 1000000 + timestampMicroseconds;
    const messageTime = pubnubTimestamp.toString();
    const providedTimestampInMicroseconds = messageTime;
    const providedTimestampInMilliseconds =
      providedTimestampInMicroseconds / 1000;
    const formattedTime = moment(providedTimestampInMilliseconds).format(
      "hh:mm a"
    );
    const dateFormated = moment(new Date()).format("DD/MM/YYYY");
    const showChat = JSON.parse(localStorage.getItem("showChat"));

    let payload = {
      _id: id,
      DateFormated: dateFormated,
      audioDuration: duration,
      author: userId,
      authorName: authorName,
      chatName: "",
      chatType: 1,
      content: content,
      enrollmentId: String(showChat._id),
      fileExtension: filename.split(".")[1],
      fileName: filename,
      fileOriginalName: "",
      filePath: path,
      hasAttachments: true,
      isDeleted: false,
      isRead: false,
      messageId: "",
      messageTime: messageTime,
      offline: true,
      replyMessage: replyMessage ? [replyMessage] : [],
      roomId: "",
      roomName: "",
      sendOnServer: true,
      senderId: userId,
      senderName: showChat.username,
      thumbnail:
        type.split("/")[0] == "video"
          ? thumbnail
          : type.includes("application")
          ? "https://imwow.s3.ap-south-1.amazonaws.com/userData/user_65382/chat_29669/pdf-bydefault_90917.png"
          : "",
      timeFormated: formattedTime,
      type: type.includes("application")
        ? "file"
        : type == "video/webm"
        ? cameraVideo == "video"
          ? "video"
          : "audio"
        : type.split("/")[0],
    };
    if (roleId == "1") {
      payload = {
        ...payload,
        participantsIds: [String(showChat.user_id), String(showChat.coach_id)],
      };
    } else {
      payload = { ...payload, participantsIds: [String(showChat.user_id)] };
    }
    if (getMessageFromLocalState) {
      const existMessage = getMessageFromLocalState.findIndex(
        (message) => message._id === payload._id
      );
      if (existMessage === -1) {
        socket.emit("send-message", payload);
        localStorage.setItem(
          "my-message",
          JSON.stringify([payload, ...getMessageFromLocalState])
        );
        setMessages((prev) => {
          return [...prev, payload];
        });
        if (replyMessage !== null) {
          setReplyMessage(null);
        }
      }
    } else if (getMessageFromLocalState === null) {
      socket.emit("send-message", payload);
      localStorage.setItem(
        "my-message",
        JSON.stringify([payload, ...getMessageFromLocalState])
      );
      setMessages((prev) => {
        return [...prev, payload];
      });
      if (replyMessage !== null) {
        setReplyMessage(null);
      }
    }
  };

  // ****************** for drag and drop file ********************
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (acceptedFiles) => {
      onFilesDropped(acceptedFiles); // handle files in parent
    },
    multiple: true,
  });

  const onFilesDropped = async (file) => {
    if (file[0].type.startsWith("video/")) {
      setDropLoading(true);
      let thumb = await generateThumbnail(file[0]);
      const newFormData = new FormData();
      newFormData.append("file[]", file[0]);
      newFormData.append("file_id", "95345234gsdg395");
      newFormData.append("subscription_id", "29674");
      newFormData.append("thumbnail[]", thumb);
      try {
        const response = await axios.post(
          `${CONSTANTS.API_BASE}/uploadmultiplechatmediaProd`,
          newFormData,
          {
            headers: {
              "Content-Type": `multipart/form-data`,
              Authorization: bearerToken,
            },
          }
        );
        const { url, path, filename, type, thumbnail } = response.data.data[0];
        handleMedia(url, path, filename, type, thumbnail, "0", "");
      } catch (error) {
        console.error("Error uploading file:", error);
        toast.error(error?.message || "Error to upload the media", {
          position: "top-center",
          autoClose: 1000,
          transition: Bounce,
        });
      } finally {
        setDropLoading(false);
      }
    } else {
      setDropLoading(true);
      const newFormData = new FormData();
      newFormData.append("file[]", file[0]);
      newFormData.append("file_id", "95345234gsdg395");
      newFormData.append("subscription_id", "29674");
      try {
        const response = await axios.post(
          `${CONSTANTS.API_BASE}/uploadmultiplechatmediaProd`,
          newFormData,
          {
            headers: {
              "Content-Type": `multipart/form-data`,
              Authorization: bearerToken,
            },
          }
        );
        const { url, path, filename, type, thumbnail } = response.data.data[0];
        handleMedia(url, path, filename, type, thumbnail, "0", "");
        // handleUpload(response.data);
      } catch (error) {
        console.error("Error uploading file:", error);
        toast.error(error?.message || "Error to upload the media", {
          position: "top-center",
          autoClose: 1000,
          transition: Bounce,
        });
      } finally {
        setDropLoading(false);
      }
    }
  };

  // ****************** for paste file ********************
  const onFilePaste = async (file) => {
    if (file.type.startsWith("video/")) {
      setDropLoading(true);
      let thumb = await generateThumbnail(file);
      const newFormData = new FormData();
      newFormData.append("file[]", file);
      newFormData.append("file_id", "95345234gsdg395");
      newFormData.append("subscription_id", "29674");
      newFormData.append("thumbnail[]", thumb);
      try {
        const response = await axios.post(
          `${CONSTANTS.API_BASE}/uploadmultiplechatmediaProd`,
          newFormData,
          {
            headers: {
              "Content-Type": `multipart/form-data`,
              Authorization: bearerToken,
            },
          }
        );
        const { url, path, filename, type, thumbnail } = response.data.data[0];
        handleMedia(url, path, filename, type, thumbnail, "0", "");
      } catch (error) {
        console.error("Error uploading file:", error);
        toast.error(error?.message || "Error to upload the media", {
          position: "top-center",
          autoClose: 1000,
          transition: Bounce,
        });
      } finally {
        setDropLoading(false);
      }
    } else {
      setDropLoading(true);
      const newFormData = new FormData();
      newFormData.append("file[]", file);
      newFormData.append("file_id", "95345234gsdg395");
      newFormData.append("subscription_id", "29674");
      try {
        const response = await axios.post(
          `${CONSTANTS.API_BASE}/uploadmultiplechatmediaProd`,
          newFormData,
          {
            headers: {
              "Content-Type": `multipart/form-data`,
              Authorization: bearerToken,
            },
          }
        );
        const { url, path, filename, type, thumbnail } = response.data.data[0];
        handleMedia(url, path, filename, type, thumbnail, "0", "");
      } catch (error) {
        console.error("Error uploading file:", error);
        toast.error(error?.message || "Error to upload the media", {
          position: "top-center",
          autoClose: 1000,
          transition: Bounce,
        });
      } finally {
        setDropLoading(false);
      }
    }
  };
  useEffect(() => {
    const handlePaste = (event) => {
      const clipboardItems = event.clipboardData.items;

      for (const item of clipboardItems) {
        if (item.kind === "file") {
          const file = item.getAsFile();
          if (file) {
            onFilePaste(file);
          }
        }
      }
    };

    window.addEventListener("paste", handlePaste);
    return () => window.removeEventListener("paste", handlePaste);
  }, [onFilePaste]);

  return (
    <div
      className={`pb-4 pt-1  flex flex-col justify-between h-full ${
        isDragActive ? "bg-blue-100" : null
      }`}
      {...getRootProps()}
    >
      <ClientAvatar avHeight="45px" />
      {!dropLoading ? (
        <div className="flex-1 overflow-hidden">
          {isDragActive && (
            <div className="absolute inset-0 z-50 flex items-center justify-center bg-gray-200 bg-opacity-50 h-[88vh]">
              <p className="text-center text-gray-700 text-2xl font-semibold">
                Drop files here to upload{" "}
                <span className="text-blue-500 font-bold text-3xl">+</span>
              </p>
            </div>
          )}

          {messages.length > 0 ? (
            <ChatBox
              setReplyMessage={setReplyMessage}
              loadOlderChat={loadOlderChat}
              setPageNumber={setPageNumber}
              totalConversationHistory={totalConversationHistory}
              loadMsgLoading={loadMsgLoading}
              setLoadMsgLoading={setLoadMsgLoading}
              showLoadmoreBtn={showLoadmoreBtn}
            />
          ) : (
            <div
              className="w-full h-[99%] bg-contain mt-1 border-t border-b overflow-y-auto  relative"
              style={{ backgroundImage: `url(${chatbackground})` }}
            ></div>
          )}
        </div>
      ) : (
        <div className="fixed inset-0 z-50  h-[88vh] backdrop-blur-sm">
          <div className="flex items-center justify-center h-full w-full">
            <img src={loaderAnimation} alt="loader" />
          </div>
        </div>
      )}
      <ChatInputComponent
        replyMessage={replyMessage}
        setReplyMessage={setReplyMessage}
        handleSendMsg={handleSendMsg}
        handleMedia={handleMedia}
      />
    </div>
  );
};

export default memo(ChatBoxComponent);
